import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useUiStore } from "@/store/ui";

/**
 * `?debug=1` включает показ «на чём стоит ответ» под сообщениями консультанта.
 * Флаг живёт в sessionStorage, чтобы переживать переходы между вкладками.
 */
export function useDebugFlag() {
  const { search } = useLocation();
  const setDebug = useUiStore((s) => s.setDebug);

  useEffect(() => {
    const params = new URLSearchParams(search);
    const value = params.get("debug");
    if (value === null) return;
    setDebug(value === "1" || value === "true");
  }, [search, setDebug]);
}
